import { Tabs } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import { purchaseTypeAtom } from '@!/atoms/paymentAtom'

export const PaymentTabs = () => {
  const navigate = useNavigate()
  const [purchaseType] = useAtom(purchaseTypeAtom)

  const tabValue = purchaseType === 'monthly' ? 'monthly' : 'coin'

  const handleTabChange = (details) => {
    if (details.value === 'monthly') {
      navigate('/monthly_course')
    } else if (details.value === 'coin') {
      navigate('/coin')
    }
  }
  return (
    <Tabs.Root variant="unstyled" value={tabValue} onValueChange={handleTabChange}>
      <Tabs.List mx={4} mb={4} bg="bg.tertiary" borderColor="bg.tertiary" borderWidth="1px" borderRadius="md" width="auto" display="flex">
        <Tabs.Trigger value="monthly" fontSize="xs" flex="1" p="6px" borderWidth="1px" borderRadius="md" _selected={{ bg: 'label.white', fontWeight: '600' }}>
          月額コース登録
        </Tabs.Trigger>
        <Tabs.Trigger value="coin" fontSize="xs" flex="1" p="6px" borderWidth="1px" borderRadius="md" _selected={{ bg: 'label.white', fontWeight: '600' }}>
          コイン追加購入
        </Tabs.Trigger>
      </Tabs.List>
    </Tabs.Root>
  )
}
